module.exports = __webpack_public_path__ + "media/src/images/trading-d48d3828df85ed9f2e429955518c94f0.png";